export const WorkerResponse = {
  ERROR: 'error',
  SUCCESS: 'success'
};

export const DecodeResponseType = {
  NOTHING: 0,
  TEXT: 1,
  JSON: 2,
  BLOB: 3
};

export const WorkerResponseCode = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  FORGOT_PWD: 'forgot_password',

  USERS_GET: 'users_get',
  USER_DELETE: 'user_delete',
  USER_POST: 'user_post',
  USER_GET: 'user_get',
  USER_PATCH: 'user_patch',
  USER_PWD_RESET_POST: 'user_pwd_reset_post',
  USER_PATCH_PUSH_TOKEN: 'user_patch_push_token',

  GROUPS_GET: 'groups_get',
  GROUP_DELETE: 'group_delete',
  GROUP_POST: 'group_post',
  GROUP_GET: 'group_get',
  GROUP_PATCH: 'group_patch',

  CUSTOMERS_GET: 'customers_get',
  CUSTOMER_DELETE: 'customer_delete',
  CUSTOMER_POST: 'customer_post',
  CUSTOMER_GET: 'customer_get',
  CUSTOMER_PATCH: 'customer_patch',

  ORDERS_GET: 'orders_get',
  ORDER_DELETE: 'order_delete',
  ORDER_POST: 'order_post',
  ORDER_GET: 'order_get',
  ORDER_PATCH: 'order_patch',

  UPLOAD_TYPES_GET: 'upload_types_get',
  UPLOAD_TYPE_POST: 'upload_type_post',
  UPLOAD_TYPE_GET: 'upload_type_get',
  UPLOAD_TYPE_PATCH: 'upload_type_patch',

  ORDER_TYPES_GET: 'order_types_get',
  ORDER_TYPE_POST: 'order_type_post',
  ORDER_TYPE_GET: 'order_type_get',
  ORDER_TYPE_PATCH: 'order_type_patch',

  DOM_GET_STATUSES: 'dom_get_statuses',
  LABELS_GET_STATUSES: 'labels_get_statuses',
  DOM_GET_PROGRESSIONS: 'dom_get_progressions',
  LABELS_GET_PROGRESSIONS: 'labels_get_progressions',
  DOM_GET_PROGRESSION_SUBSTATUSES: 'dom_get_progression_substatuses',
  LABELS_GET_PROGRESSION_SUBSTATUSES: 'labels_get_progression_substatuses',
  DOM_GET_PROVINCES: 'dom_get_provinces',
  LABELS_GET_NOTIFICATIONS: 'labels_get_notifications',
  DOM_GET_NOTIFICATIONS: 'dom_get_notifications',

  UPLOAD_MEDIA: 'upload_document',
  GET_MEDIA: 'get_media',
  DELETE_MEDIA: 'delete_media',

  GLOBALS_GET: 'globals_get',

  ORDER_STATS_GET: 'order_stats_get'
};
